import { render } from "./RequestCart.vue?vue&type=template&id=2f2cd68a"
import script from "./RequestCart.vue?vue&type=script&lang=js"
export * from "./RequestCart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__